import numeral from 'numeral';
let uniqueId = 0
export function getUniqueKey () {
  uniqueId += 1
  return `${Date.now()}-${uniqueId}`
}

/**
 * 阻止DOM事件冒泡
 * @param {Event} event
 */
export function stopPropagation (event) {
  event.stopPropagation()
}
/**
 * 获取企微版本，如果不是企微，返回null
 * @return {string|null}
 */
export function getWxworkVersion () {
  const matchRes = navigator.userAgent.toLowerCase().match(/\bwxwork\/([\d.]+)\b/)
  if (matchRes) {
    return matchRes[1]
  } else {
    return null
  }
}
// 数字格式化
export const numberFormat = (value, precision = 0) => {
  const prefix = '0,0';
  const suffix = precision ? `.${'0'.repeat(precision)}` : '';
  const format = prefix + suffix;
  return numeral(value).format(format);
};


// WEBPACK FOOTER //
// ./src/utils/index.js